/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::383e1e515699ed041e3d29c8001f5850>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */
import React from 'react';

import { ThirdPartyLogoWrapper } from '../wrapper';
import type { ThirdPartyLogoProps } from './types';

const markup =
	'<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#225086" d="M14.254 33.435c.728.454 1.937.958 3.216.958a5.8 5.8 0 0 0 3.143-.913l.003-.002 3.385-2.115v7.638a2.9 2.9 0 0 1-1.545-.44z"/><path fill="#6df" d="M21.85 9.95 7.787 25.815c-1.086 1.226-.803 3.079.606 3.958l5.861 3.664c.728.454 1.937.958 3.216.958a5.8 5.8 0 0 0 3.142-.913l.004-.002 3.385-2.115-8.183-5.115 8.185-9.233V9a2.87 2.87 0 0 0-2.153.95"/><path fill="#cbf8ff" d="m15.818 26.245.097.06 8.086 5.055h.002V17.014L24 17.012z"/><path fill="#074793" d="M39.609 29.772c1.408-.88 1.691-2.732.605-3.958l-9.227-10.409a5.8 5.8 0 0 0-2.462-.546 5.73 5.73 0 0 0-4.316 1.924l-.205.23 8.183 9.234-8.185 5.115v7.637a2.9 2.9 0 0 0 1.544-.439l14.063-8.79z"/><path fill="#0294e4" d="M24.003 9v8.016l.204-.23a5.72 5.72 0 0 1 4.316-1.925c.886 0 1.718.201 2.462.546L26.15 9.953A2.86 2.86 0 0 0 24 9.002z"/><path fill="#96bcc2" d="m32.185 26.247-8.183-9.231V31.36z"/></svg>';

/**
 * __MicrosoftEntraIDIcon__
 *
 * A third-party logo icon for Microsoft Entra ID.
 */
export function MicrosoftEntraIDIcon({
	size,
	label = 'Microsoft Entra ID',
	testId,
	type,
	UNSAFE_isUpdatedGeometry,
}: ThirdPartyLogoProps): React.JSX.Element {
	return (
		<ThirdPartyLogoWrapper
			markup={markup}
			label={label}
			size={size}
			testId={testId}
			type={type}
			UNSAFE_isUpdatedGeometry={UNSAFE_isUpdatedGeometry}
		/>
	);
}
